export const blockIconsHouseholdCoffeeNew = (
	<span className='material-symbols-outlined'>coffee</span>
);
